export default __webpack_public_path__ + "static/Poppins-Light-7641a0f76ca9ef6c252ce242f76e8b1d.ttf";